import React from "react";
import { useLogin } from "@refinedev/core";
import { Button, Card, Form, Input, Layout, Typography } from "antd";

export const LoginPage: React.FC = () => {
  const { mutate: login, isLoading } = useLogin<{ username: string; password: string }>();
  return <Layout style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
    <Card style={{ width: 380 }}>
      <Typography.Title level={3}>Evolutivo Compliance</Typography.Title>
      <Typography.Paragraph type="secondary">Accedi con le tue credenziali.</Typography.Paragraph>
      <Form layout="vertical" onFinish={(values) => login(values)}>
        <Form.Item name="username" label="Utente" rules={[{ required: true }]}><Input autoComplete="username" /></Form.Item>
        <Form.Item name="password" label="Chiave di accesso" rules={[{ required: true }]}><Input.Password autoComplete="current-password" /></Form.Item>
        <Button block type="primary" htmlType="submit" loading={isLoading}>Accedi</Button>
      </Form>
    </Card>
  </Layout>;
};
